<li
  *ngFor="let item of items | map: sortAndGroupByItem"
  class="fls-0-0 fld-row flg-4 ai-ctr vwmx-p100"
>
  <span class="fls-0-0 line-item-count">{{ item.orderedQty }}</span>
  <span class="fls-0-0">&times;</span>
  <span class="fls-1-1">{{ item.name }}</span>
  <myqq-price [price]="item.grossTotal"></myqq-price>
</li>
